import UserRolesTable from "./UserRolesTable";
import AddRoleToUserDialog from "./add-rol/AddRoleToUserDialog";
import UserPermissionsTable from "./UserPermissionsTable";
import OverviewTabContent from "../../../../../../../shared/components/overview-panel/OverviewTabContent";
import OverviewTabs from "../../../../../../../shared/components/overview-panel/OverviewTabs";

const UserInfoTabMenu = ({ roles, permissions }) => {
  const tabs = [
    {
      trigger: { value: "roles", label: "Roles" },
      content: (
        <OverviewTabContent
          value="roles"
          title="Roles"
          description="Roles asignados al usuario"
          options={
            <AddRoleToUserDialog
              onSubmitHandler={roles.onRoleAddition}
              roles={roles.available}
            />
          }
        >
          <UserRolesTable data={roles.data} onDelete={roles.onRoleDeletion} />
        </OverviewTabContent>
      ),
    },
    {
      trigger: { value: "permissions", label: "Permisos" },
      content: (
        <OverviewTabContent
          value="permissions"
          title="Permisos"
          description="Permisos asignados al usuario"
        >
          <UserPermissionsTable data={permissions} />
        </OverviewTabContent>
      ),
    },
  ];

  return (
    <div className="grid flex-1 items-start gap-4 p-4 sm:px-6 sm:py-0 md:gap-8">
      <OverviewTabs tabs={tabs} defaultTabValue="roles" />
    </div>
  );
};

export default UserInfoTabMenu;
